import * as React from "react";
import { context } from "components/context/Context";
import { useContext } from "react";
import { useParams } from "react-router-dom";

type Roles = "Admin" | "Club" | "None";
const useAuthAndPath = (
  fn: (onAuth: boolean | null, role: Roles, clubID: string | null) => void,
  arr: any[]
) => {
  const { state } = useContext(context);
  const { clubID } = useParams<{ clubID?: string }>();
  const onAuth = typeof state.onAuth === "boolean" ? state.onAuth : null;
  const role = isValidRoleString(state.character) ? state.character : "None";
  const clubid = typeof clubID === "string" ? clubID : null;

  React.useEffect(() => {
    fn(onAuth, role, clubid);
  }, arr);
};

const isValidRoleString = (str: string): str is Roles => {
  return str === "Admin" || str === "Club";
};

export default useAuthAndPath;
